export default "__VITE_ASSET__UYxPLWMq__"